export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11817.b7008fe5.jpg";